import { createContext } from 'react';
export var DropdownContext = createContext({
  isVisible: true
});